import authRoles from 'app/auth/authRoles';
import MapViewOfSchools from './MapViewOfSchools';
import React from 'react';

const MapViewConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/MapView',
			element: (
				<React.Suspense fallback={<>...</>}>
					<MapViewOfSchools />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default MapViewConfig;
